import { StyledPracticeCell } from "../../../components/Table.styled"
import { getYears } from "./utils/helpers"

const QuarterHeader = () => {
  const currentYear = new Date().getFullYear()
  const years = getYears(currentYear - 1)
  const quarters: string[] = ['Q1', 'Q2', 'Q3', 'Q4']

  return (
    <StyledPracticeCell>
      <div className="flex">
        {
          years.map(year => {
            return quarters.map(quarter => (
              <div key={`${year}-${quarter}`} className="quarter-label flex">
                <span>{quarter}</span>
              </div>
            ))
          })
        }
      </div>
    </StyledPracticeCell>
  )
}

export default QuarterHeader